import React, { useEffect, useState } from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import MessageContainer from '../components/Message/MessageContainer';
import { ImageClipboardProvider } from '../hooks/imageClipboard';
import { useTabVisibility } from '../hooks/tabVisibility';
import { useMessage } from '../hooks/message';
import { unescapeHtml } from '../services/function';

import ChatIcon from '../assets/icon/mensagemBold.svg';
import DataMessageIcon from '../assets/icon/dataMessage.svg';

const Chat: React.FC<any> = () => {
  const atendFinalizadoCliente = 3;
  const atendPerdidoCliente = 5;

  const [msgModal, setMsgModal] = useState('');
  const {
    messages,
    clientsAccepted,
    getMensages,
    updateMensageReadAtendimento,
  } = useMessage();
  const [searchParams] = useSearchParams();

  const [showModalClosedChat, setShowModalClosedChat] = useState(false);

  const id =
    searchParams.get('id') === null ? 0 : Number(searchParams.get('id'));

  const dataClient = clientsAccepted.find(
    (client) => client.seqAtendimento === id
  );

  if (messages.length === 0) {
    getMensages(id, []);
  }

  const handleCloseChat = (): void => {
    setShowModalClosedChat(false);
  };

  useEffect(() => {
    updateMensageReadAtendimento(id);
  }, [id]);

  useEffect(() => {
    if (dataClient?.seqStatusAtendimento === atendFinalizadoCliente) {
      setMsgModal('O atendimento foi encerrado pelo cliente.');
      setShowModalClosedChat(true);
    } else if (dataClient?.seqStatusAtendimento === atendPerdidoCliente) {
      setMsgModal('A conexão com o cliente foi perdida.');
      setShowModalClosedChat(true);
    }
  }, [dataClient]);

  return (
    <>
      <Modal show={showModalClosedChat} onHide={() => handleCloseChat()}>
        <Modal.Header closeButton>
          <Modal.Title>Atenção</Modal.Title>
        </Modal.Header>
        <Modal.Body>{msgModal}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleCloseChat()}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
      {dataClient !== undefined && (
        <div className="h-100">
          <h1
            className="ms-2 "
            style={{ fontSize: '2.5rem', fontWeight: '600' }}
          >
            Chat
          </h1>
          <div className="d-flex w-100 bg-light ps-2 h-100">
            <section
              className="d-flex flex-column w-70 me-2 overflow-hidden"
              style={{
                borderRadius: '0.68rem',
                height: 'Calc(100vh - 14.4rem)',
                boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
                flex: 1,
              }}
            >
              <div
                className="d-flex align-items-center"
                style={{ backgroundColor: '#D9D9D9' }}
              >
                <Image
                  className="ms-2"
                  src={ChatIcon}
                  alt="Chat Icon"
                  style={{
                    maxHeight: '1.56rem',
                    maxWidth: '1.56rem',
                  }}
                />
                <span
                  className="ms-2"
                  style={{
                    fontSize: '1.68rem',
                    fontWeight: '600',
                    color: '#000',
                  }}
                >
                  {dataClient?.nomeCliente}
                </span>
              </div>
              <ImageClipboardProvider>
                <MessageContainer
                  messages={messages.find(
                    (message) => message.seqAtendimento === id
                  )}
                />
              </ImageClipboardProvider>
            </section>
            <section
              className="col-4 overflow-hidden bg-white me-2 d-flex flex-column"
              style={{
                borderRadius: '0.68rem',
                height: 'Calc(100vh - 14.4rem)',
                boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
              }}
            >
              <div
                className="d-flex align-items-center"
                style={{ backgroundColor: '#1A1A1A' }}
              >
                <Image
                  className="ms-2"
                  style={{ maxWidth: '2rem', maxHeight: '2rem' }}
                  src={DataMessageIcon}
                  alt="Dados da mensagem"
                />
                <span
                  className="text-white ms-2"
                  style={{ fontSize: '1.68rem', fontWeight: '600' }}
                >
                  Dados da mensagem
                </span>
              </div>
              <div className="container  bg-body  overflow-scroll d-flex flex-column flex-grow-1">
                <div
                  className="d-flex"
                  style={{
                    fontSize: '1.25rem',
                  }}
                >
                  <span style={{ fontWeight: '600', width: '11rem' }}>
                    Nome:
                  </span>
                  <span
                    style={{
                      wordWrap: 'break-word',
                      width: '22rem',
                    }}
                  >
                    {dataClient?.nomeCliente}
                  </span>
                </div>
                <div
                  className="d-flex mt-2"
                  style={{
                    fontSize: '1.25rem',
                  }}
                >
                  <span style={{ fontWeight: '600', width: '11rem' }}>
                    E-mail:
                  </span>
                  <span
                    style={{
                      wordWrap: 'break-word',
                      width: '22rem',
                    }}
                  >
                    {dataClient?.emailCliente}
                  </span>
                </div>
                <div
                  className="d-flex mt-2"
                  style={{
                    fontSize: '1.25rem',
                  }}
                >
                  <span style={{ fontWeight: '600', width: '11rem' }}>
                    Dúvida:
                  </span>
                  <span
                    style={{
                      wordWrap: 'break-word',
                      width: '22rem',
                    }}
                  >
                    {unescapeHtml(dataClient?.duvida)}
                  </span>
                </div>
                <div
                  className="d-flex mt-2"
                  style={{
                    fontSize: '1.25rem',
                  }}
                >
                  <span
                    style={{
                      fontWeight: '600',
                      width: '11rem',
                      wordWrap: 'break-word',
                    }}
                  >
                    Empresa / Cidade / Estado:
                  </span>
                  <span
                    style={{
                      wordWrap: 'break-word',
                      width: '22rem',
                    }}
                  >
                    {dataClient?.nomeClinica}
                  </span>
                </div>
                <div
                  className="d-flex mt-2"
                  style={{
                    fontSize: '1.25rem',
                  }}
                >
                  <span
                    style={{
                      fontWeight: '600',
                      width: '11rem',
                      wordWrap: 'break-word',
                    }}
                  >
                    Produto / No. Contrato:
                  </span>
                  <span
                    style={{
                      wordWrap: 'break-word',
                      width: '22rem',
                    }}
                  >
                    {dataClient?.nomeProduto}
                  </span>
                </div>
                <div
                  className="d-flex mt-2"
                  style={{
                    fontSize: '1.25rem',
                  }}
                >
                  <span
                    style={{
                      fontWeight: '600',
                      width: '11rem',
                      wordWrap: 'break-word',
                    }}
                  >
                    Departamento:
                  </span>
                  <span
                    style={{
                      wordWrap: 'break-word',
                      width: '22rem',
                    }}
                  >
                    {dataClient?.nomeDepartamento}
                  </span>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default Chat;
